import { HTMLAttributes } from 'react';
import PureImage from '../../../common/Image/PureImage';
import PureLink from '../../../common/Link/PureLink';
import { ContentBlock } from '../../../../lib/types/aemDataModels';
import { SCALE } from '../../../common/Image/ImageScale';
import styles from './Tile.module.scss';
import { classes } from '../../../../lib/utils/cssUtils';

const Tile = ({
  link,
  linkLabel,
  asset,
  className,
  uniqueId,
  heading,
  content,
  ...rest
}: ContentBlock & HTMLAttributes<HTMLLIElement>) => {
  return (
    <li className={classes(styles.tileContainer, className)} {...rest}>
      <PureLink href={link} className={styles.tileLink}>
        <div className={styles.imageContainer}>
          <PureImage src={asset?.path ?? ''} className={styles.image} scale={SCALE.TILE_GRID} />
        </div>
        <div className={styles.label}>{linkLabel}</div>
      </PureLink>
    </li>
  );
};

export default Tile;
